import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import { confetti } from "@/lib/celebrate";
import { vaultWin } from "@/lib/vaultSounds";
import { VaultDoor } from "@/components/vault/VaultDoor";

const GOLD = ["#FBBF24", "#FDE68A", "#F59E0B", "#FFFFFF"];
const COINS = Array.from({ length: 26 }, (_, i) => ({ left: (i * 37) % 100, delay: 2.1 + (i % 9) * 0.17, dur: 1.6 + (i % 5) * 0.25, size: 14 + (i % 4) * 6 }));

function useCount(target, startDelay, ms = 1400) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf, t0;
    const tick = (t) => { t0 ??= t; const p = Math.min(1, (t - t0) / ms); setN(Math.round(target * (1 - Math.pow(1 - p, 3)))); if (p < 1) raf = requestAnimationFrame(tick); };
    const to = setTimeout(() => { raf = requestAnimationFrame(tick); }, startDelay);
    return () => { clearTimeout(to); cancelAnimationFrame(raf); };
  }, [target, startDelay, ms]);
  return n;
}

export function VaultWinOverlay({ win, onShare, onClose, note = "Ein neuer Tresor ist schon offen" }) {
  const [open, setOpen] = useState(false);
  const pot = useCount(win.pot, 2100);
  useEffect(() => {
    vaultWin();
    const a = setTimeout(() => setOpen(true), 950);
    const b = setTimeout(() => confetti({ count: 140, spread: 1.8, colors: GOLD }), 2150);
    const c = setTimeout(() => confetti({ y: innerHeight * 0.3, count: 90, spread: 1.4, colors: GOLD }), 2900);
    return () => [a, b, c].forEach(clearTimeout);
  }, []);
  return (
    <div className="fixed inset-0 z-[90] grid place-items-center bg-slate-950/90 backdrop-blur-md p-6 vault-pop" data-testid="vault-win-overlay">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute left-1/2 top-[38%] w-[160vmax] h-[160vmax] -translate-x-1/2 -translate-y-1/2 vault-rays transition-opacity duration-700 ${open ? "opacity-100" : "opacity-0"}`} />
        {COINS.map((c, i) => <i key={i} className="vault-coin-fall" style={{ left: `${c.left}%`, width: c.size, height: c.size, animationDelay: `${c.delay}s`, animationDuration: `${c.dur}s` }} />)}
      </div>
      <div className="relative text-center text-white space-y-4 max-w-sm">
        <div className="vault-door-shake"><VaultDoor size={220} angle={1080} lit={4} open={open} /></div>
        <p className={`font-display text-3xl font-black text-amber-300 transition-[opacity,transform] duration-500 ${open ? "opacity-100 scale-100" : "opacity-0 scale-75"}`}>TRESOR GEKNACKT!</p>
        <p className="font-display text-6xl font-black tabular-nums text-amber-200 vault-pot" data-testid="vault-win-points">+{pot.toLocaleString("de-DE")}</p>
        <p className="text-sm text-white/70">Der Code war <b className="text-amber-200 tracking-[0.3em]">{win.code}</b> · {note}</p>
        <div className="flex gap-2 justify-center pt-2">
          {onShare && <button onClick={onShare} data-testid="vault-win-share" className="h-12 px-5 rounded-full bg-gradient-to-r from-amber-300 to-amber-500 text-slate-900 font-extrabold inline-flex items-center gap-2"><Share2 className="w-4 h-4" /> Teilen</button>}
          <button onClick={onClose} data-testid="vault-win-close" className="h-12 px-5 rounded-full bg-white/10 font-bold">Weiter</button>
        </div>
      </div>
    </div>
  );
}
